import { render, staticRenderFns } from "./DeliverySetting.vue?vue&type=template&id=ea13558e&scoped=true&"
import script from "./DeliverySetting.vue?vue&type=script&lang=js&"
export * from "./DeliverySetting.vue?vue&type=script&lang=js&"
import style0 from "./DeliverySetting.vue?vue&type=style&index=0&id=ea13558e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea13558e",
  null
  
)

export default component.exports